import styled from '@emotion/styled';
import { formatNumber } from 'utils/numberFormat';
import { useTranslate } from '@tolgee/react';
import { Space } from 'antd';
import Icon from '@ant-design/icons';
import Currency from 'components/Currency';
import { ReactComponent as DiscountIcon } from '../assets/erqi/discount.svg';
import { PriceText } from './PriceText';

interface TotalPrice {
  // 实付价格
  actualPrice: number;
  // 立减价格
  reducePrice?: number;
  // 原价格
  originPrice?: number;
}

export interface NonEnterpriseTotalProps {
  currency: General.Currency;
  totalPrices: TotalPrice;
  children?: React.ReactNode;
}

export const NonEnterpriseTotal = (props: NonEnterpriseTotalProps) => {
  const { currency, children, totalPrices } = props;
  const { t } = useTranslate();
  const { actualPrice, reducePrice } = totalPrices;

  return (
    <Container>
      <Space size={8}>
        <TotalLabel>{t('market.总计')}</TotalLabel>
        <ActualPrice>
          <PriceText currency={currency} price={actualPrice} />
        </ActualPrice>
        {reducePrice && reducePrice > 0 ? (
          <ReducePrice>
            <Icon component={DiscountIcon} />
            {t('market.限时优惠')}
            {formatNumber(reducePrice, '0,0')}
            <Currency value={currency} />
          </ReducePrice>
        ) : null}
      </Space>
      {children}
    </Container>
  );
};

const Container = styled.div({
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: 'var(--fett-erp-card-bg)',
  padding: '12px 16px',
});

const TotalLabel = styled.h3({
  display: 'inline-block',
  fontSize: '16px',
  fontWeight: 500,
  color: 'var(--fett-text-primary)',
  margin: 0,
});

const ActualPrice = styled.div`
  display: inline-flex;
  align-items: center;
  font-size: 32px;
  font-weight: 500;
  color: var(--fett-colors-price);

  > span {
    margin-top: -8px;
    padding: 0 8px;
    font-size: 36px;
  }
`;

export const ReducePrice = styled.div`
  display: flex;
  align-items: center;
  background: #fae6e6;
  color: var(--fett-colors-price);
  padding: 2px 6px;
  font-size: 12px;
  border-radius: 8px;
  border-bottom-left-radius: 0;

  span.anticon {
    font-size: 14px;
    margin-right: 2px;
  }
`;
